import FloorPlanTable, { type TableHighlightingMode } from './FloorPlanTable';
import type { TableIconCommonProps } from './InteractiveFloorPlanTable';

const FULLY_VISIBLE_OPACITY = 1;
const DIMMED_OPACITY = 0.3;

export interface NonInteractiveFloorPlanTableProps
  extends TableIconCommonProps {
  isDimmed?: boolean;
  isHighlighted: boolean;
  tableHighlightingMode?: TableHighlightingMode;
  showHoverStroke?: boolean;
}

export const NonInteractiveFloorPlanTable = ({
  iconName,
  iconWidthScale,
  isDimmed = false,
  isHighlighted,
  left,
  orientation,
  tableHighlightingMode = 'outline',
  tableIconScale,
  testId,
  top,
  showHoverStroke,
}: NonInteractiveFloorPlanTableProps) => (
  <FloorPlanTable
    data-testid={testId}
    left={left}
    tableIconScale={tableIconScale}
    top={top}
  >
    <FloorPlanTable.Icon
      iconName={iconName}
      iconWidthScale={iconWidthScale}
      isHighlighted={isHighlighted}
      orientation={orientation}
      style={{
        opacity: isDimmed ? DIMMED_OPACITY : FULLY_VISIBLE_OPACITY,
      }}
      tableIconScale={tableIconScale}
      tableHighlightingMode={tableHighlightingMode}
      showHoverStroke={showHoverStroke}
    />
  </FloorPlanTable>
);
